import Vue from 'vue';
import App from './app.vue';
import '@/i18n/locale.js';
import '../../assets/scss/reset.scss';
import '@u/common.js';

new Vue({
  el: '#app',
  render: (h) => h(App)
});
